import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';

export interface UsdaServiceFeConfig {
  endpoint?: string;
  apiKey?: string;
}

export const USDA_SERVICE_FE_CONFIG = new InjectionToken<UsdaServiceFeConfig>(
  'USDA_SERVICE_FE_CONFIG',
);

export function provideUsdaServiceFe(
  config: UsdaServiceFeConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: USDA_SERVICE_FE_CONFIG,
      useValue: config,
    },
  ]);
}
